import { Skeleton, SkeletonProps } from "@/components/ui/Skeleton";
import { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface PatientDrawerTitleProps {
  children: ReactNode;
  end?: ReactNode;
  className?: string;
}

export function PatientDrawerTitle({
  children,
  end,
  className,
}: PatientDrawerTitleProps) {
  return (
    <div className={twMerge("flex items-center gap-2", className)}>
      <p className="m-0 text-lg leading-[1.2] font-bold tracking-[-0.02em]">
        {children}
      </p>
      {end}
    </div>
  );
}

export function PatientDrawerTitleSkeleton({
  className,
  active = true,
  ...props
}: SkeletonProps) {
  return (
    <Skeleton
      {...props}
      active={active}
      className={twMerge("h-[22px] w-[120px]", className)}
    />
  );
}
